//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

// export const 'API_BASE' = new InjectionToken<string>(''API_BASE'');


////////////// NOTE : THIS CLIENT SERVICE IS USED IN OTHER MODULES
////////////// PROVIDE IN ROOT
@Injectable({ providedIn : 'root'})
////////////// PROVIDE IN ROOT
export class AuthenticationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject('API_BASE') baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:57809";
    }

    getAuthTokens(user: string | null, password: string | null): Observable<AuthenticateTokenResult | null> {
        let url_ = this.baseUrl + "/authentication/get-auth-tokens?";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (password === undefined)
            throw new Error("The parameter 'password' must be defined.");
        else if(password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthTokens(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthTokens(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateTokenResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateTokenResult | null>;
        }));
    }

    protected processGetAuthTokens(response: HttpResponseBase): Observable<AuthenticateTokenResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateTokenResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuthTokens2(web_forms_sso_token: string | null): Observable<AuthenticateTokenResult | null> {
        let url_ = this.baseUrl + "/authentication/get-auth-tokens-2?";
        if (web_forms_sso_token === undefined)
            throw new Error("The parameter 'web_forms_sso_token' must be defined.");
        else if(web_forms_sso_token !== null)
            url_ += "web_forms_sso_token=" + encodeURIComponent("" + web_forms_sso_token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthTokens2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthTokens2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateTokenResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateTokenResult | null>;
        }));
    }

    protected processGetAuthTokens2(response: HttpResponseBase): Observable<AuthenticateTokenResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateTokenResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshNgAuthToken(ngToken: string | null, user: string | null): Observable<string | null> {
        let url_ = this.baseUrl + "/authentication/refresh-ng-auth-token?";
        if (ngToken === undefined)
            throw new Error("The parameter 'ngToken' must be defined.");
        else if(ngToken !== null)
            url_ += "ngToken=" + encodeURIComponent("" + ngToken) + "&";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshNgAuthToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshNgAuthToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processRefreshNgAuthToken(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkUpdateSession(ngToken: string | null, user: string | null): Observable<string | null> {
        let url_ = this.baseUrl + "/authentication/update-session-data?";
        if (ngToken === undefined)
            throw new Error("The parameter 'ngToken' must be defined.");
        else if(ngToken !== null)
            url_ += "ngToken=" + encodeURIComponent("" + ngToken) + "&";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUpdateSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUpdateSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processCheckUpdateSession(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshWebFormsLoginToken(ngToken: string | null, user: string | null): Observable<string | null> {
        let url_ = this.baseUrl + "/authentication/refresh-web-forms-login-token?";
        if (ngToken === undefined)
            throw new Error("The parameter 'ngToken' must be defined.");
        else if(ngToken !== null)
            url_ += "ngToken=" + encodeURIComponent("" + ngToken) + "&";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshWebFormsLoginToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshWebFormsLoginToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string | null>;
        }));
    }

    protected processRefreshWebFormsLoginToken(response: HttpResponseBase): Observable<string | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changePassword(user: string | null, password: string | null, newPassword: string | null): Observable<ChangePasswordResult> {
        let url_ = this.baseUrl + "/authentication/change-password?";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (password === undefined)
            throw new Error("The parameter 'password' must be defined.");
        else if(password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (newPassword === undefined)
            throw new Error("The parameter 'newPassword' must be defined.");
        else if(newPassword !== null)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangePasswordResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangePasswordResult>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ChangePasswordResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAuthTokensForDevelopment(user: string | null): Observable<AuthenticateTokenResult | null> {
        let url_ = this.baseUrl + "/authentication/get-auth-tokens-dev?";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuthTokensForDevelopment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuthTokensForDevelopment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateTokenResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateTokenResult | null>;
        }));
    }

    protected processGetAuthTokensForDevelopment(response: HttpResponseBase): Observable<AuthenticateTokenResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? AuthenticateTokenResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEmailAddressHint(user: string | null): Observable<GetEmailHintResult | null> {
        let url_ = this.baseUrl + "/authentication/forget-password/get-email-address-hint?";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEmailAddressHint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEmailAddressHint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmailHintResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmailHintResult | null>;
        }));
    }

    protected processGetEmailAddressHint(response: HttpResponseBase): Observable<GetEmailHintResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? GetEmailHintResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    sendResetPasswordLink(user: string | null, confirmEmail: string | null): Observable<SendResetPasswordEmailResult | null> {
        let url_ = this.baseUrl + "/authentication/forget-password/send-reset-email?";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (confirmEmail === undefined)
            throw new Error("The parameter 'confirmEmail' must be defined.");
        else if(confirmEmail !== null)
            url_ += "confirmEmail=" + encodeURIComponent("" + confirmEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendResetPasswordLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendResetPasswordLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendResetPasswordEmailResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendResetPasswordEmailResult | null>;
        }));
    }

    protected processSendResetPasswordLink(response: HttpResponseBase): Observable<SendResetPasswordEmailResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? SendResetPasswordEmailResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordAuthenticate(token: string | null, password: string | null): Observable<ResetPasswordAuthenticateResult | null> {
        let url_ = this.baseUrl + "/authentication/forget-password/authentiate-to-reset?";
        if (token === undefined)
            throw new Error("The parameter 'token' must be defined.");
        else if(token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (password === undefined)
            throw new Error("The parameter 'password' must be defined.");
        else if(password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordAuthenticateResult | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordAuthenticateResult | null>;
        }));
    }

    protected processResetPasswordAuthenticate(response: HttpResponseBase): Observable<ResetPasswordAuthenticateResult | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? ResetPasswordAuthenticateResult.fromJS(resultData200) : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordSetPassword(token: string | null, user: string | null, password: string | null): Observable<ChangePasswordResult> {
        let url_ = this.baseUrl + "/authentication/forget-password/set-password?";
        if (token === undefined)
            throw new Error("The parameter 'token' must be defined.");
        else if(token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (user === undefined)
            throw new Error("The parameter 'user' must be defined.");
        else if(user !== null)
            url_ += "user=" + encodeURIComponent("" + user) + "&";
        if (password === undefined)
            throw new Error("The parameter 'password' must be defined.");
        else if(password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordSetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordSetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChangePasswordResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChangePasswordResult>;
        }));
    }

    protected processResetPasswordSetPassword(response: HttpResponseBase): Observable<ChangePasswordResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AuthenticateTokenResult implements IAuthenticateTokenResult {
    result!: AuthenticateResult;
    ngToken?: string | undefined;
    webFormsToken?: string | undefined;
    user?: string | undefined;

    constructor(data?: IAuthenticateTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"];
            this.ngToken = _data["NgToken"];
            this.webFormsToken = _data["WebFormsToken"];
            this.user = _data["User"];
        }
    }

    static fromJS(data: any): AuthenticateTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["NgToken"] = this.ngToken;
        data["WebFormsToken"] = this.webFormsToken;
        data["User"] = this.user;
        return data;
    }
}

export interface IAuthenticateTokenResult {
    result: AuthenticateResult;
    ngToken?: string | undefined;
    webFormsToken?: string | undefined;
    user?: string | undefined;
}

export enum AuthenticateResult {
    Unknown = 0,
    Success = 1,
    InvalidUserNameorPassword = 2,
    LockedOutOfSystem = 3,
    PasswordChangeRequired = 4,
    UnknownError = 10,
    Token_IsEmptyNotProvided = 20,
    Token_InvalidOrExpiredToken = 21,
    Session_ConfigInvalid = 41,
    Session_MaxConcurrentLoginReached = 42,
}

export enum ChangePasswordResult {
    Unknown = 0,
    Success = 1,
    UnableToAuthenticateUser = 3,
    InvalidPassword_MustBeNew = 4,
    PasswordInvalid_ContainsSpaces = 5,
    PasswordInvalid_Minimum8Charachters = 6,
    PasswordInvalid_SpecialCharachtersUnmet = 7,
    UnknownError = 10,
    Invalid_TokenExpired = 22,
}

export class GetEmailHintResult implements IGetEmailHintResult {
    isSuccess!: boolean;
    message?: string | undefined;
    emailHint?: string | undefined;

    constructor(data?: IGetEmailHintResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["IsSuccess"];
            this.message = _data["Message"];
            this.emailHint = _data["EmailHint"];
        }
    }

    static fromJS(data: any): GetEmailHintResult {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmailHintResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsSuccess"] = this.isSuccess;
        data["Message"] = this.message;
        data["EmailHint"] = this.emailHint;
        return data;
    }
}

export interface IGetEmailHintResult {
    isSuccess: boolean;
    message?: string | undefined;
    emailHint?: string | undefined;
}

export class SendResetPasswordEmailResult implements ISendResetPasswordEmailResult {
    isSuccess!: boolean;
    message?: string | undefined;

    constructor(data?: ISendResetPasswordEmailResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["IsSuccess"];
            this.message = _data["Message"];
        }
    }

    static fromJS(data: any): SendResetPasswordEmailResult {
        data = typeof data === 'object' ? data : {};
        let result = new SendResetPasswordEmailResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["IsSuccess"] = this.isSuccess;
        data["Message"] = this.message;
        return data;
    }
}

export interface ISendResetPasswordEmailResult {
    isSuccess: boolean;
    message?: string | undefined;
}

export class ResetPasswordAuthenticateResult implements IResetPasswordAuthenticateResult {
    result!: AuthenticateResult;
    resetPasswordToken?: string | undefined;
    user?: string | undefined;

    constructor(data?: IResetPasswordAuthenticateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["Result"];
            this.resetPasswordToken = _data["ResetPasswordToken"];
            this.user = _data["User"];
        }
    }

    static fromJS(data: any): ResetPasswordAuthenticateResult {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordAuthenticateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["Result"] = this.result;
        data["ResetPasswordToken"] = this.resetPasswordToken;
        data["User"] = this.user;
        return data;
    }
}

export interface IResetPasswordAuthenticateResult {
    result: AuthenticateResult;
    resetPasswordToken?: string | undefined;
    user?: string | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}